import type { ReactNode } from 'react';

/** Monospace inline value (versions, keys, counts). */
export function Mono({ children }: { children: ReactNode }) {
  return (
    <span style={{ fontFamily: 'var(--mantine-font-family-monospace)', fontSize: 13 }}>
      {children}
    </span>
  );
}
